import {
  GET_BRAND_CRM,
  SAVE_BRAND_CRM,
  TEST_BRAND_CRM,
  DELETE_BRAND_CRM,
} from "../actionTypes";

// --- GET ---
const getBrandCrmDefState = {
  getBrandCrmLoading: false,
  getBrandCrmData: null,
  getBrandCrmError: null,
};

export const getBrandCrmReducer = (state = getBrandCrmDefState, action) => {
  switch (action.type) {
    case GET_BRAND_CRM.REQUEST:
      return {
        ...state,
        getBrandCrmLoading: true,
        getBrandCrmError: null,
      };
    case GET_BRAND_CRM.SUCCESS:
      return {
        getBrandCrmLoading: false,
        getBrandCrmData: action.payload,
        getBrandCrmError: null,
      };
    case GET_BRAND_CRM.ERROR:
      return {
        getBrandCrmLoading: false,
        getBrandCrmData: null,
        getBrandCrmError: action.payload,
      };
    default:
      return state;
  }
};

// --- SAVE ---
const saveBrandCrmDefState = {
  saveBrandCrmLoading: false,
  saveBrandCrmData: null,
  saveBrandCrmError: null,
};

export const saveBrandCrmReducer = (state = saveBrandCrmDefState, action) => {
  switch (action.type) {
    case SAVE_BRAND_CRM.REQUEST:
      return {
        saveBrandCrmLoading: true,
        saveBrandCrmData: null,
        saveBrandCrmError: null,
      };
    case SAVE_BRAND_CRM.SUCCESS:
      return {
        saveBrandCrmLoading: false,
        saveBrandCrmData: action.payload,
        saveBrandCrmError: null,
      };
    case SAVE_BRAND_CRM.ERROR:
      return {
        saveBrandCrmLoading: false,
        saveBrandCrmData: null,
        saveBrandCrmError: action.payload,
      };
    case SAVE_BRAND_CRM.RESET:
      return saveBrandCrmDefState;
    default:
      return state;
  }
};

// --- TEST ---
const testBrandCrmDefState = {
  testBrandCrmLoading: false,
  testBrandCrmData: null,
  testBrandCrmError: null,
};

export const testBrandCrmReducer = (state = testBrandCrmDefState, action) => {
  switch (action.type) {
    case TEST_BRAND_CRM.REQUEST:
      return {
        testBrandCrmLoading: true,
        testBrandCrmData: null,
        testBrandCrmError: null,
      };
    case TEST_BRAND_CRM.SUCCESS:
      return {
        testBrandCrmLoading: false,
        testBrandCrmData: action.payload,
        testBrandCrmError: null,
      };
    case TEST_BRAND_CRM.ERROR:
      return {
        testBrandCrmLoading: false,
        testBrandCrmData: null,
        testBrandCrmError: action.payload,
      };
    case TEST_BRAND_CRM.RESET:
      return testBrandCrmDefState;
    default:
      return state;
  }
};

// --- DELETE ---
const deleteBrandCrmDefState = {
  deleteBrandCrmLoading: false,
  deleteBrandCrmData: null,
  deleteBrandCrmError: null,
};

export const deleteBrandCrmReducer = (
  state = deleteBrandCrmDefState,
  action,
) => {
  switch (action.type) {
    case DELETE_BRAND_CRM.REQUEST:
      return {
        deleteBrandCrmLoading: true,
        deleteBrandCrmData: null,
        deleteBrandCrmError: null,
      };
    case DELETE_BRAND_CRM.SUCCESS:
      return {
        deleteBrandCrmLoading: false,
        deleteBrandCrmData: action.payload,
        deleteBrandCrmError: null,
      };
    case DELETE_BRAND_CRM.ERROR:
      return {
        deleteBrandCrmLoading: false,
        deleteBrandCrmData: null,
        deleteBrandCrmError: action.payload,
      };
    case DELETE_BRAND_CRM.RESET:
      return deleteBrandCrmDefState;
    default:
      return state;
  }
};
